import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Form, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { SelectItem, SelectItemGroup } from 'primeng/api';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { AcModel } from 'projects/core/src/lib/models/ac.model';
import { CandidateModel } from 'projects/core/src/lib/models/candidate.model';

class CustomCandidateModel extends CandidateModel {
  control?: UntypedFormControl;
}

@Component({
  selector: 'app-order-detail-finish-dialog',
  templateUrl: './order-detail-finish-dialog.component.html',
  styleUrls: ['./order-detail-finish-dialog.component.scss']
})
export class OrderDetailFinishDialogComponent implements OnInit {

  @Input() order: AcModel = null;
  @Input() options: { [key: string]: Array<SelectItem | SelectItemGroup> } = {};

  @Output() closed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<AcModel>();

  public submitting = false;
  public form: UntypedFormGroup = this.fb.group({});
  public candidates: Array<CustomCandidateModel> = [];

  constructor(
    private api: ApiService,
    private fb: UntypedFormBuilder,
    private ui: UiService,
    public transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    if (this.order?.candidates && this.options?.recommendations) {
      this.candidates = this.order.candidates.map((candidate: CandidateModel) => {
        const value = this.options.recommendations.find((recommendation: any) => recommendation.id === candidate.result?.recommendation?.id) || null;
        const control = this.fb.control(value, [Validators.required]);
        if (value !== null) {
          control.disable();
        }
        return new CustomCandidateModel().deserialize({ ...candidate, control });
      });
    }
  }

  public onCancel(): void {
    this.closed.emit();
  }

  public onSubmit(): void {
    if (this.form.valid) {
      this.submitting = true;
      const payload = this.candidates.reduce((obj, candidate: CustomCandidateModel) => {
        obj[candidate.id] = candidate.control.value?.id;
        return obj;
      }, {});
      this.api.finishOrder(this.order?.id, payload).subscribe({
        next: (result: any) => {
          this.ui.toastSuccess(this.transloco.translate('finish_order.messages.success'));
          this.submitted.emit(new AcModel().deserialize(result.data));
        },
        error: (error: any) => {
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
